// extracted by mini-css-extract-plugin
module.exports = {"StepsContentWrap":"createuserscreen_StepsContentWrap__35DA8","StepsContent":"createuserscreen_StepsContent__2W38G","StepsWrapper":"createuserscreen_StepsWrapper__2cZdj"};